import React, { useState } from "react";
import AttendanceInput from "Components/Form/AttendanceInput";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
const MonthlyAttendanceRow = ({ workingDays, employeeDetails, dispatch }) => {
  const [showDetails, setShowDetails] = useState(false);
  const useFormData = useFormContext();
  const { register, setValue, getValues, watch } = useFormData;

  const attendaInput = [];

  for (let i = 0; i < workingDays; i++) {
    attendaInput.push(
      <th>
        <AttendanceInput
          row={i}
          employeeCode={employeeDetails.employeeCode}
          showDetails={showDetails}
          useFormData={useFormData}
          dispatch={dispatch}
          key={i}
        />{" "}
      </th>
    );
  }
  return (
    <tr>
      <th>
        {" "}
        <input
          type="checkbox"
          {...register(`isPresent[${employeeDetails.employeeCode}]`)}
          checked={watch(`isPresent[${employeeDetails.employeeCode}]`)}
          onClick={(e) => {
            dispatch({
              type: "MARK_PRESENT",
              data: {
                status: e.target.checked,
                id: employeeDetails.employeeCode,
              },
            });
          }}
        />
      </th>
      <th>
        <div>
          {employeeDetails.fullName}&nbsp;
          <button
            type="button"
            className="btn"
            onClick={() => setShowDetails((prev) => !prev)}
          >
            <i className="fa fa-solid fa-info"></i>
          </button>
        </div>
      </th>
      {attendaInput.map((attendance) => attendance)}
    </tr>
  );
};

MonthlyAttendanceRow.propTypes = {
  workingDays: PropTypes.number.isRequired,
  employeeDetails: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default MonthlyAttendanceRow;
